import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Buys from 'pages/Engines/Buys/Buys';
import CopyrightKey from 'pages/Engines/CopyrightKey/CopyrightKey';
import Email from 'pages/Engines/Email/Email';
import Ip from 'pages/Engines/Ip/Ip';
import Link from 'pages/Engines/Link/Link';
import Md5Key from 'pages/Engines/Md5Key/Md5Key';
import MonitoringServiceKey from 'pages/Engines/MonitoringServiceKey/MonitoringServiceKey';
import Regenerate from 'pages/Engines/Regenerate/Regenerate';
import Error from 'pages/Error/Error';
import Index from 'pages/Index/Index';

const Router = () => {
	return (
		<Routes>
			<Route path="/" element={<Index />} />
			<Route path="/engines/buys" element={<Buys />} />
			<Route path="/engines/ip" element={<Ip />} />
			<Route path="/engines/email" element={<Email />} />
			<Route path="/engines/link" element={<Link />} />
			<Route path="/engines/regenerate" element={<Regenerate />} />
			<Route path="/engines/monitoring-service-key" element={<MonitoringServiceKey />} />
			<Route path="/engines/md5-key" element={<Md5Key />} />
			<Route path="/engines/copyright-key" element={<CopyrightKey />} />
			<Route path="/*" element={<Error />} />
		</Routes>
	);
};

export default Router;
